import { DotLottieReact } from "@lottiefiles/dotlottie-react";

export default function LogoSpinner() {
  return (
    <DotLottieReact
      src="https://lottie.host/9ce95de1-701b-4d54-969c-772d52666454/EYWiURpiQr.lottie"
      loop
      autoplay
    />
  );
}
